import { render } from "./VehicleItemDesktopHorizontal.vue?vue&type=template&id=cae23a2c"
import script from "./VehicleItemDesktopHorizontal.vue?vue&type=script&lang=js"
export * from "./VehicleItemDesktopHorizontal.vue?vue&type=script&lang=js"

import "./VehicleItemDesktopHorizontal.vue?vue&type=style&index=0&id=cae23a2c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__